/**
 * Formatta la data di ultimo aggiornamento di un documento legale nella lingua di
 * chi legge (es. «4 luglio 2026»).
 *
 * L'ingresso e' la data civile ISO (YYYY-MM-DD) del frontmatter markdown, non un
 * `Date`: va letta come giorno di calendario, quindi viene scomposta a mano.
 * `new Date('2026-07-04')` la interpreterebbe come mezzanotte UTC, che a ovest di
 * Greenwich e' ancora il 3.
 */
export function formatLegalDate(isoDate: string, language: string): string {
  const [year, month, day] = isoDate.split('-').map(Number);
  if (!year || !month || !day) return isoDate;
  const date = new Date(year, month - 1, day);
  const options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' };
  try {
    return new Intl.DateTimeFormat(language, options).format(date);
  } catch {
    return new Intl.DateTimeFormat('en', options).format(date);
  }
}
